module.exports = __webpack_public_path__ + "img/f8.69365bdc.png";